async function goToCheckout() {
    // Wrap the click action in a promise
    const clickAddButton = new Promise((resolve) => {
        const addButton = document.querySelector('button[name="add"]');
        if (addButton) {
            addButton.click();
            /* Assuming there is some asynchronous operation to complete after click
            Replace setTimeout with the actual logic to detect the completion of click event's asynchronous operations
			*/
            setTimeout(resolve, 2000);
        } else {
            console.error('Add button not found');
			// Resolve immediately if button is not found
            resolve();
        }
    });

    // Perform click and wait for any asynchronous operations to complete
    await clickAddButton;

    // Proceed with other actions
    document.querySelector('body').classList.remove('cart-drawer-is-open');

    const lineItemPrice = [...document.querySelectorAll('.product-price')];
    const fadeEffects = lineItemPrice.map((priceElement, index) => {
        return new Promise((resolve) => {
            priceElement.style.opacity = '0';
            setTimeout(() => {
                lineItemPrice[index].style.opacity = '1';
                resolve();
            }, 1000);
        });
    });

    // Wait for all fade effects to complete
    await Promise.all(fadeEffects);

    // Redirect to checkout page
    window.location.href = '/checkout';
}

/* check for scroll and atc button */
function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

window.addEventListener("scroll", function () {
	if (isInViewport(document.querySelector(".second-atc"))) {
		document.querySelector(".product-form__sticky").classList.add("sticky-hidden");
	} else {
		document.querySelector(".product-form__sticky").classList.remove("sticky-hidden");
	}
});

/* price flicker on atc fix */
window.addEventListener("load", function () {
	const lineItemPrice = [...document.querySelectorAll(".product-price")];
	lineItemPrice.forEach((arrayElement, index) => {
		lineItemPrice[index].style.opacity = "0";
		setTimeout(function () {
			lineItemPrice[index].style.opacity = "1";
		}, 1050);
	});

	var swiper = new Swiper(".swiper-container--upsell-slides", {
		observer: !0,
		threshold: 10,
		direction: "horizontal",
		navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
		breakpoints: {
			320: { slidesPerView: 2.4, spaceBetween: 16 },
			1200: { slidesPerView: 3, spaceBetween: 16 },
			1920: { slidesPerView: 3.2, spaceBetween: 25 },
		},
	});
	var swiper = new Swiper(".product-recommendations-main", {
		direction: "horizontal",
		observer: !0,
		threshold: 10,
		navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
		breakpoints: {
			320: { slidesPerView: 2.4, spaceBetween: 16 },
			768: { slidesPerView: 3, spaceBetween: 40 },
			1200: { slidesPerView: 4, spaceBetween: 40 },
			1920: { slidesPerView: 4, spaceBetween: 40 },
		},
	});

	/* add to cart button and upsell button */
	document.querySelector('.product-form__sticky button[type="submit"]').addEventListener("click", function () {
		document.querySelector("#AddToCart").click();

		/* cart upsell */

		setTimeout(function () {
			let cartInner = document.querySelector(".cart-item-size dd").innerText;
			document.querySelectorAll(".upsell-product__item").forEach((cartitem) => {
				if (cartitem.getAttribute("data-variant") == cartInner) {
					document.querySelector(".product__upsell-products").classList.add("visible");
					document.querySelector(".product__upsell-products").classList.remove("hidden");
					cartitem.classList.remove("hidden");
					cartitem.classList.add("upsell-product__item-active");
					//document.querySelector('.upsell-products__title').style.display = "block";
				} else {
					document.querySelector(".product__upsell-products").classList.remove("visible");
					document.querySelector(".product__upsell-products").classList.add("hidden");
					cartitem.classList.add("hidden");
					cartitem.classList.remove("upsell-product__item-active");
					//document.querySelector('.upsell-products__title').style.display = "none";
				}
			});
		}, 1500);
	});

	/* add to cart button and upsell button */
	document.querySelector("#AddToCart").addEventListener("click", function () {
		/* cart upsell */

		setTimeout(function () {
			let cartInner = document.querySelector(".cart-item-size dd").innerText;
			console.log("cartInner", cartInner);
			document.querySelectorAll(".upsell-product__item").forEach((cartitem) => {
				if (cartitem.getAttribute("data-variant") == cartInner) {
					document.querySelector(".product__upsell-products").classList.add("visible");
					document.querySelector(".product__upsell-products").classList.remove("hidden");
					cartitem.classList.remove("hidden");
				} else {
					document.querySelector(".product__upsell-products").classList.add("hidden");
					document.querySelector(".product__upsell-products").classList.remove("visible");
					cartitem.classList.add("hidden");
				}
			});
		}, 1500);
	});

	document.querySelector("#cart-icon-bubble").addEventListener("click", function () {
		/* cart upsell */
		setTimeout(function () {
			let cartInner = document.querySelector(".cart-item-size dd").innerText;
			console.log("cartInner", cartInner);
			document.querySelectorAll(".upsell-product__item").forEach((cartitem) => {
				if (cartitem.getAttribute("data-variant") == cartInner) {
					cartitem.classList.remove("hidden");
					document.querySelector(".cart-drawer__upsell .h4").style.display = "block";
				} else {
					cartitem.classList.add("hidden");
					document.querySelector(".cart-drawer__upsell .h4").style.display = "none";
				}
			});
		}, 1500);
	});

	const upsell_boxes = document.querySelectorAll(".product-card--upsell a.full-unstyled-link");
	upsell_boxes.forEach((upsell_box) => {
		upsell_box.addEventListener("click", function (event) {
			event.preventDefault();
			event.target.closest(".product-card--upsell").querySelector("#UpsellAdd").click();
		});
	});

	/* upsell straps */
	const params = new URLSearchParams(window.location.search);
	const variant_id = parseInt(params.get("variant"));
	const variant = JSON.parse(document.querySelector("script[data-product-variants-json]").innerText.trim()).find(
		(variant) => {
			return variant.id == variant_id;
		}
	);

	var element = document.querySelector("body .product__upsell-products");
	if (typeof element != "undefined" && element != null) {
		if (variant.inventory_quantity < 1) {
			document.querySelector("body .product__upsell-products").style.display = "none";
		} else {
			document.querySelector("body .product__upsell-products").style.display = "block";
		}
	}
	document.querySelectorAll(".upsell-product__item").forEach((upsell) => {
		let loadUP = JSON.parse(upsell.querySelector('script[type="application/json"]').innerText.trim()).find(
			(variant) => {
				return variant.option1 == variant.option1;
			}
		).id;
		upsell.querySelector('[name="id"]').value = loadUP;
		if (upsell.getAttribute("data-variant") == variant.option1) {
			setTimeout(function () {
				if (upsell.closest(".product__upsell-products")) {
					upsell.closest(".product__upsell-products").classList.add("visible");
					upsell.closest(".product__upsell-products").classList.remove("hidden");
				}
			}, 800);
			upsell.classList.remove("hidden");
			upsell.classList.add("upsell-product__item-active");
			//document.querySelector('.upsell-products__title').style.display = "block";
		} else {
			if (upsell.closest(".product__upsell-products")) {
				upsell.closest(".product__upsell-products").classList.remove("visible");
				upsell.closest(".product__upsell-products").classList.add("hidden");
			}
			upsell.classList.add("hidden");
			upsell.classList.remove("upsell-product__item-active");
			//document.querySelector('.upsell-products__title').style.display = "none";
		}
	});

	var root = document.documentElement;
	const lists = document.querySelectorAll(".swiper-container--upsell-slides-new .upsell-wrapper");

	lists.forEach((el) => {
		const listItems = el.querySelectorAll(".upsell-product__item-active");
		const n = listItems.length;
		el.style.setProperty("--total", n);
		uSize = window.innerWidth;
		console.log("window size", uSize);
		console.log("--total", n);
		if (uSize > 1640 && n < 4) {
			document.querySelector("#left-button").style.display = "none";
			document.querySelector("#right-button").style.display = "none";
			document.querySelector(".upsell_wrapper_upperscreen").style.overflowX = "hidden";
		} else if (uSize < 1639 && n < 3) {
			document.querySelector("#left-button").style.display = "none";
			document.querySelector("#right-button").style.display = "none";
		} else {
			document.querySelector("#left-button").style.display = "flex";
			document.querySelector("#right-button").style.display = "flex";
			document.querySelector(".upsell_wrapper_upperscreen").style.overflowX = "scroll";
		}
	});

	if (lists.length > 0) {
		const rightBtn = document.querySelector("#right-button");
		const leftBtn = document.querySelector("#left-button");
		var left = 0;
		rightBtn.addEventListener("click", function (event) {
			const scrollContainer = document.querySelector("#upsell_container");
			left = left - 100;
			scrollContainer.scrollTo({
				left: left - 100,
				behavior: "smooth",
			});
			event.preventDefault();
		});

		leftBtn.addEventListener("click", function (event) {
			const scrollContainer = document.querySelector("#upsell_container");
			left = left + 100;
			scrollContainer.scrollTo({
				left: left + 100,
				behavior: "smooth",
			});
			event.preventDefault();
		});
	}
}); // on load

/* variant out of stock / badges */
document.body.addEventListener("variant-change", (e) => {
	const lineItemPrice = [...document.querySelectorAll(".product-price")];
	lineItemPrice.forEach((arrayElement, index) => {
		lineItemPrice[index].style.opacity = "0";
		setTimeout(function () {
			lineItemPrice[index].style.opacity = "1";
		}, 1050);
	});

	let prePolicy = e.detail.variant.inventory_policy;
	let preQty = e.detail.variant.inventory_quantity;
	
	// Check if product has preorder tag (product-level, not variant-level)
	const productDataScript = document.querySelector("script[data-product-variants-json]");
	let hasPreorderTag = false;
	if (productDataScript) {
		const productData = JSON.parse(productDataScript.textContent.trim());
		// Check if any variant or the script's parent has preorder info, or check form input
		const tagsInput = document.querySelector('input[name="[_properties]"]');
		if (tagsInput && tagsInput.value) {
			hasPreorderTag = tagsInput.value.toLowerCase().includes("preorder");
		}
	}

	if (prePolicy == "continue" && preQty < 1 && hasPreorderTag) {
		document.querySelector(".pre-order").classList.remove("hidden");
		document.querySelector(".pre-order").classList.add("visible");
	} else {
		document.querySelector(".pre-order").classList.add("hidden");
		document.querySelector(".pre-order").classList.remove("visible");
	}

	let comparePrice = parseInt(e.detail.variant.compare_at_price);
	let currentCartFromBackend = parseInt(e.detail.variant.price);

	document.querySelectorAll(".upsell-product__item").forEach((upsell) => {
		let changeUP = JSON.parse(upsell.querySelector('script[type="application/json"]').innerText.trim()).find(
			(variant) => {
				return variant.option1 == e.detail.variant.option1;
			}
		).id;
		upsell.querySelector('[name="id"]').value = changeUP;
		if (upsell.getAttribute("data-variant") == e.detail.variant.option1) {
			setTimeout(function () {
				upsell.querySelector("button").removeAttribute("disabled");
			}, 500);
			console.log(upsell.closest(".product__upsell-products"));
			if (upsell.closest(".product__upsell-products")) {
				upsell.closest(".product__upsell-products").classList.add("visible");
				upsell.closest(".product__upsell-products").classList.remove("hidden");
			}
			upsell.classList.remove("hidden");
			upsell.classList.add("upsell-product__item-active");
			//document.querySelector('.upsell-products__title').style.display = "block";
		} else {
			if (upsell.closest(".product__upsell-products")) {
				upsell.closest(".product__upsell-products").classList.remove("visible");
				upsell.closest(".product__upsell-products").classList.add("hidden");
			}
			upsell.classList.add("hidden");
			upsell.classList.remove("upsell-product__item-active");
			// document.querySelector('.upsell-products__title').style.display = "none";
		}
	});

	var root = document.documentElement;
	const lists = document.querySelectorAll(".swiper-container--upsell-slides-new .upsell-wrapper");

	lists.forEach((el) => {
		const listItems = el.querySelectorAll(".upsell-product__item-active");
		const n = listItems.length;
		el.style.setProperty("--total", n);
		uSize = window.innerWidth;
		if (uSize > 1640 && n < 4) {
			document.querySelector("#left-button").style.display = "none";
			document.querySelector("#right-button").style.display = "none";
			document.querySelector(".upsell_wrapper_upperscreen").style.overflowX = "hidden";
		} else if (uSize < 1639 && n < 3) {
			document.querySelector("#left-button").style.display = "none";
			document.querySelector("#right-button").style.display = "none";
		} else {
			document.querySelector("#left-button").style.display = "flex";
			document.querySelector("#right-button").style.display = "flex";
			document.querySelector(".upsell_wrapper_upperscreen").style.overflowX = "scroll";
		}
	});

	if (document.querySelector(".product__badge--discount")) {
		if (isNaN(comparePrice)) {
			document.querySelector(".product__badge--discount").classList.remove("hidden");
			document.querySelector(".product__badge--discount").classList.add("visible");
		} else {
			document.querySelector(".product__badge--discount").classList.remove("visible");
			document.querySelector(".product__badge--discount").classList.add("hidden");
		}
	}

	if (e.detail.variant.available) {
		document.querySelector(".second-atc .checkout").classList.remove("hidden");
		document.querySelector(".atc.button--primary").classList.remove("hidden");
		document.querySelector(".second-atc .product-price").classList.remove("hidden");
		document.querySelector(".main-klaviyo").classList.add("hidden");
		document.querySelector(".bottom-klaviyo").classList.add("hidden");
		document.querySelector(".oos-related").classList.add("hidden");
		document.querySelector(".oos-related").classList.remove("visible");
		document.querySelector(".main-klaviyo").classList.remove("visible");
		document.querySelector(".bottom-klaviyo").classList.remove("visible");
		document.querySelector("body .fixed-button").classList.remove("hidden");
		document.querySelector(".button--secondary.checkout").removeAttribute("disabled");
		document.querySelector("body .fixed-button .product-price").classList.remove("hidden");
		// document.querySelector(".second-atc .product-price").innerHTML = currentCartFromBackend;
		const priceWrapper = document.querySelector('[name="add-fixed"]').querySelector(".product-price");
		document.querySelector(".second-atc .product-price").innerHTML = priceWrapper.innerHTML;
	} else {
		document.querySelector(".atc.button--primary").classList.add("hidden");
		document.querySelector(".second-atc .checkout").classList.add("hidden");
		document.querySelector(".second-atc .product-price").classList.add("hidden");
		document.querySelector(".main-klaviyo").classList.remove("hidden");
		document.querySelector(".bottom-klaviyo").classList.remove("hidden");
		document.querySelector(".main-klaviyo").classList.add("visible");
		document.querySelector(".bottom-klaviyo").classList.add("visible");
		document.querySelector(".oos-related").classList.add("visible");
		document.querySelector(".oos-related").classList.remove("hidden");
		document.querySelector("body .fixed-button").classList.add("hidden");
		document.querySelector("body .fixed-button .product-price").classList.add("hidden");
	}

	if (preQty < 1) {
		if (document.querySelector("body .product__upsell-products")) {
			document.querySelector("body .product__upsell-products").style.display = "none";
			document.querySelector(".product__upsell-products").classList.remove("visible");
			document.querySelector(".product__upsell-products").classList.add("hidden");
		} else {
			if (document.querySelector("body .product__upsell-products")) {
				document.querySelector("body .product__upsell-products").style.display = "block";
				document.querySelector(".product__upsell-products").classList.remove("hidden");
				document.querySelector(".product__upsell-products").classList.add("visible");
			}
		}
	}
});
